import { render, staticRenderFns } from "./CreateOrganization.vue?vue&type=template&id=a1a262a8&scoped=true"
import script from "./CreateOrganization.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateOrganization.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateOrganization.vue?vue&type=style&index=0&id=a1a262a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a262a8",
  null
  
)

export default component.exports